import VendorDetailsAdminPartial from "../../../partials/admin/vendors/vendor-details.admin.partial";

export default function VendorDetailsAdminScreen() {
  return <VendorDetailsAdminPartial />;
}
